<template>
  <v-container fluid>
    <v-toolbar class="mb-4">
      <v-toolbar-title>Users
        <v-btn icon small  color="info" :to="{ name: 'users-form', params: { user_id: 0 }}"><v-icon size="18">add</v-icon></v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="app_filter">
	      <v-btn v-if="filter.onlyTrashed" class="my-0" color="error" @click="getWorkUsers">Archived Users</v-btn>
	      <v-btn v-else class="my-0" color="success" @click="getArchivedUsers">Working users</v-btn>
        <div class="app_filter__item app_filter__item--search">
          <v-text-field dense v-model="filter.search" clearable label="Search by name"></v-text-field>
        </div>
      </div>
    </v-toolbar>
    <v-card>
      <v-data-table :headers="headers" :loading="inProgress" :pagination.sync="list.pagination" :total-items="list.pagination.totalItems" :items="list.items">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.email }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-right ">
              <div class="table_actions_btns">
                <v-btn
                  icon
                  small
                  :to="{ name: 'users-form', params: { user_id: props.item.id }}"
                  color="success"
                  :ripple="false"
                >
                  <v-icon size="18">edit</v-icon>
                </v-btn>

                <remove-dialog :yes="() => softDelete(props.item)">
                  <v-btn color="error" icon small :ripple="false">
                    <v-icon size="18">delete</v-icon>
                  </v-btn>
                </remove-dialog>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins/'

  export default {
    name: 'UsersListPage',
    mixins: [mixins.removable, mixins.list, mixins.filter, mixins.sort, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.users,
		    isArchive: false,
        filter: {
          withoutInstanceFilter: 1,
          search: null,
		      onlyTrashed: '',
        },
        headers: [
          { text: 'Name', align: 'left', sortable: true, value: 'name' },
          { text: 'Email', align: 'left', sortable: true, value: 'email' },
          { text: 'Phone number', align: 'left', sortable: true, value: 'phone' },
          { text: 'Action', align: 'right', sortable: false },
        ],
      }
    },
    methods: {
      getArchivedUsers() {
        this.filter.onlyTrashed =  true
        this.isArchive = true
        let params = {
          page: this.list.pagination.page,
          limit: this.list.pagination.rowsPerPage
        }

        if (typeof this.collectSort === "function") {
          params = this.collectSort(params)
        }

        if (typeof this.collectFilter === "function") {
          params = this.collectFilter(params)
        }
        this.queue(this.getData(params))
      },
      changeQuery() {
        this.$router.push({path: this.$route.path, query: this.collectFilter()}, () => {
        })
      },
      getWorkUsers() {
        this.filter.onlyTrashed =  ''
        this.load()
      },
      onMounted() {
        this.background(this.getData(this.filter) .then(() => {
          this.filter = {
            ...this.filter,
            ...this.$route.query,
            columns: [this.$route.query.columns].flat().filter(item => item).map(item => item && parseInt(item)),
            users: [this.$route.query.users].flat().filter(item => item).map(item => item && parseInt(item)),
          }
        }))
      }
    },
    mounted() {
      this.onMounted()
    },
    watch: {
      filter: {
        handler() {
          this.changeQuery()
        },
        deep: true
      },
      '$route.params.users'() {
        this.onMounted()
      }
    },
  }
</script>
